
$(document).ready(function () {
    $('.tab_content a').on('click', function (e) {
        e.preventDefault();
        var activateItem = $(this).data('activate');
        // alert(activateItem);
        $('.tab_content a').removeClass('active');
        $('.garages_horaires--days').removeClass('active');
        $('.garages_horaires--days[data-horaire="' + activateItem + '"]').addClass('active');


        $(this).addClass('active');
    });

    
    
});